// extracted by mini-css-extract-plugin
export default {"headline":"styles__headline__xWER9","list-table":"styles__list-table__Ja_dp","listTable":"styles__list-table__Ja_dp"};